/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@tonic-one/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import DataTrack from '../../components/DataTrack';
import { PermissionNameEnum } from '@Types/permissions';
import { usePermissionStore } from '../../models/usePermissionModel';
import { useReportTabsStore } from '../../models/useReportTabsModel';
import { usePrimaryBoxStyle } from '../../style';
import common from '../../utils/common';
import GenerateReports from './GenerateReports';
import OneTimeReports from './OneTimeReports';
import ScheduleReports from './ScheduleReports';

const Report = () => {
  const primaryBoxStyle = usePrimaryBoxStyle();
  const reportTabsModel = useReportTabsStore();
  const { tabStatus, setTabStatus } = reportTabsModel;
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const tabs = [
    t('reportCommon.tabs.generatedReport'),
    t('reportCommon.tabs.scheduledReport'),
    t('reportCommon.tabs.oneTimeReport'),
  ];
  const permissionModel = usePermissionStore();
  const [tableRefresh, setTableRefresh] = useState(false);
  const [scheduleRefresh, setScheduleRefresh] = useState(false);

  const onTabToggle = (index: number) => {
    setTabStatus({ tabIndex: index, submitSuccess: undefined });
  };

  useEffect(() => {
    const index = tabStatus.tabIndex;
    if (index === 0) {
      setTableRefresh(true);
      if (tabStatus?.submitSuccess) {
        window.showNotification({
          titleMsg: t('reportCommon.alert.createReport.success'),
          bodyMsg: t('reportCommon.alert.createReport.successDesc'),
          severity: 'success',
        });
      }
    } else {
      setTableRefresh(false);
    }
    if (index === 1) {
      setScheduleRefresh(true);
      if (location?.state?.scheduleSuccess === 'create') {
        window.showNotification({
          titleMsg: t('reportCommon.alert.createSchedule.success'),
          severity: 'success',
        });
        navigate(location.pathname, { state: {}, replace: true });
      } else if (location?.state?.scheduleSuccess === 'update') {
        window.showNotification({
          titleMsg: t('reportCommon.alert.updateSchedule.success'),
          severity: 'success',
        });
        navigate(location.pathname, { state: {}, replace: true });
      }
    } else {
      setScheduleRefresh(false);
    }
  }, [tabStatus]);

  return (
    <Box style={{ position: 'relative' }} {...primaryBoxStyle}>
      <Tabs pt="24px" index={tabStatus.tabIndex} onChange={onTabToggle}>
        <TabList>
          {tabs.map((i, index) => {
            return (
              <Tab key={`tab${index}`} fontSize={14}>
                {tabs[index]}
              </Tab>
            );
          })}
        </TabList>
        <TabPanels>
          <TabPanel>
            {tableRefresh && (
              <GenerateReports
                withEditPermission={common.withEditPermission(
                  PermissionNameEnum.report,
                  permissionModel.permissions
                )}
              />
            )}
          </TabPanel>
          <DataTrack type="Report.Tab.ScheduledReports.Click">
            <TabPanel>
              {scheduleRefresh && (
                <ScheduleReports
                  withEditPermission={common.withEditPermission(
                    PermissionNameEnum.report,
                    permissionModel.permissions
                  )}
                />
              )}
            </TabPanel>
          </DataTrack>
          <DataTrack type="Report.Tab.OneTimeReports.Click">
            <TabPanel>
              <OneTimeReports
                withEditPermission={common.withEditPermission(
                  PermissionNameEnum.report,
                  permissionModel.permissions
                )}
              />
            </TabPanel>
          </DataTrack>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default Report;
